import React, { useEffect, useRef, useState } from 'react';
import { PrimaryButton } from '../components/button';
import { Constants } from '../lib/const/constants';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { encryptPayload } from '../utils/encryption';

export default function BusinessDetails() {
    const navigate = useNavigate();
    const dropdownRef = useRef(null);

    const [data, setData] = useState([]);
    const [companydata, setCompanydata] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [activity, setActivity] = useState("");
    const [turnover, setTurnover] = useState("");
    const [selectedAddress, setselectedAddress] = useState("");
    const [selectedcompanyName, setSelectedcompanyName] = useState("");
    const [selectedcompanyNumber, setSelectedcompanyNumber] = useState("");
    const [selectedcompanyAddress, setSelectedcompanyAddress] = useState("");
    const [selectedcompanyPostalCode, setSelectedcompanyPostalCode] = useState("");
    const [selectedcompanyStatus, setSelectedcompanyStatus] = useState("");
    const [selectedcompanyCountry, setSelectedcompanyCountry] = useState("");
    const [selectedcompanyStreet, setSelectedcompanyStreet] = useState("");
    const [selectedcompanyHouseNumber, setSelectedcompanyHouseNumber] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [selectedType, setSelectedType] = useState('');

    // Close dropdown if clicked outside
    useEffect(() => {
        const onClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', onClickOutside);
        return () => document.removeEventListener('mousedown', onClickOutside);
    }, []);

    const setAsyncData = async (key, data) => {
        sessionStorage.setItem(key, data);
    };

    const loadData = async () => {
        const token = sessionStorage.getItem('registrationToken');
        try {
            const resp = await axios.get(Constants.BASE_URL + "API-FX-167-ENTITY-TYPES", {
                headers: {
                    fx_key: Constants.SUBSCRIPTION_KEY,
                    Authorization: 'Bearer ' + token
                }
            });
            setData(resp.data.data);
        } catch (err) {
            console.log("error", err.response);
        }
    };

    const searchCompany = async () => {
        setLoading(true);
        const token = sessionStorage.getItem('registrationToken');
        try {
            const resp = await axios.get(Constants.BASE_URL + "API-FX-168-COMPANY-SEARCH?name=" + search, {
                headers: {
                    fx_key: Constants.SUBSCRIPTION_KEY,
                    Authorization: 'Bearer ' + token
                }
            });
            setCompanydata(resp.data.data);
        } catch (err) {
            console.log("error", err.response);
        } finally {
            setLoading(false);
        }
    };

    const submitData = async () => {
        setLoading(true);

        // Save all selected data to sessionStorage
        const keys = [
            ['activity', activity],
            ['turnover', turnover],
            ['selectedAddress', selectedAddress],
            ['selectedcompanyName', selectedcompanyName],
            ['selectedcompanyNumber', selectedcompanyNumber],
            ['selectedcompanyAddress', selectedcompanyAddress],
            ['selectedcompanyPostalCode', selectedcompanyPostalCode],
            ['selectedcompanyStatus', selectedcompanyStatus],
            ['selectedcompanyCountry', selectedcompanyCountry],
            ['selectedcompanyStreet', selectedcompanyStreet],
            ['selectedcompanyHouseNumber', selectedcompanyHouseNumber]
        ];

        keys.forEach(([key, value]) => setAsyncData(key, value));

        const deviceId = sessionStorage.getItem('deviceid');
        const userid = sessionStorage.getItem('userid');

        try {
            const dropPayload = await encryptPayload({
                screen_name: "BUSINESS_DETAILS_6",
                meta: {
                    activity,
                    turnover,
                    selectedAddress,
                    selectedcompanyName,
                    selectedcompanyNumber,
                    selectedcompanyAddress,
                    selectedcompanyPostalCode,
                    selectedcompanyStatus,
                    selectedcompanyCountry,
                    selectedcompanyStreet,
                    selectedcompanyHouseNumber
                },
                device_id: deviceId,
                user_id: userid
            });

            const dropresponse = await axios.post(Constants.BASE_URL + "API-FX-159-DROPSCREEN", dropPayload, {
                headers: { fx_key: Constants.SUBSCRIPTION_KEY }
            });
            console.log("dropscreen", dropresponse.data);
            navigate('/AboutBusiness');
        } catch (err) {
            console.log(err);
            toast.error(err.response?.data?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className="min-h-screen w-full bg-white flex flex-col">
            <div className="w-full border-b border-[#0B214E33] py-6 px-6">
                <img src="/fx_logo_old.png" alt="FXMaster Logo" className="w-[160px]" />
            </div>

            <ToastContainer />

            <div className='flex flex-1 items-center justify-center px-4'>
                <div className="w-full max-w-lg flex flex-col gap-4">
                    {/* Back Button */}
                    <div className="flex items-center mb-1 pt-3 cursor-pointer" onClick={() => navigate("/SumSubRegister")}>
                        <img src="./arrow-left.svg" alt="back" />
                        <span className="text-lg font-bold ml-2">Business Details</span>
                    </div>

                    <p className='text-[#868685] font-semibold'>As a part of banking compliance, you are required to identify yourself and your business</p>

                    {/* Company Type Dropdown */}
                    <div ref={dropdownRef} className="relative w-full">
                        <div
                            className="bg-[#EAEAEA] border border-gray-300 text-gray-900 text-sm rounded-lg px-4 py-2 cursor-pointer flex justify-between items-center w-full"
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            {selectedType ? <span>{selectedType}</span> : <span className="text-[#000000]">Company Type</span>}
                            <img src="./icons/down-arrow-icon.svg" alt="dropdown" />
                        </div>

                        {isOpen && (
                            <ul className="absolute left-0 right-0 mt-2 z-10 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-auto">
                                {data.length ? (
                                    data.map((types, index) => (
                                        <li
                                            key={index}
                                            className="px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                                            onClick={() => {
                                                setSelectedType(types.name);
                                                setAsyncData('company_type', types.name);
                                                setIsOpen(false);
                                            }}
                                        >
                                            {types.name}
                                        </li>
                                    ))
                                ) : (
                                    <li className="px-4 py-2 text-sm text-[#707070]">No options</li>
                                )}
                            </ul>
                        )}
                    </div>

                    {/* Search Company */}
                    <div className="flex items-center bg-custom-gray-light rounded-md w-full">
                        <input
                            type="text"
                            placeholder="Search Company"
                            className="w-full p-2 outline-none rounded-md bg-custom-gray-light placeholder:text-[#000000] placeholder:text-sm"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <img className="cursor-pointer pr-2" src="./icons/search-icon.svg" onClick={searchCompany} alt="Search Icon" />
                    </div>
                    {loading && <p className="text-sm text-gray-500">Searching...</p>}

                    {/* Select Company */}
                    {companydata.length > 0 && (
                        <select
                            onChange={(event) => {
                                const value = event.target.value;
                                const splitted = value.split("__");
                                setSelectedcompanyName(splitted[0]);
                                setSelectedcompanyNumber(splitted[1]);
                                setSelectedcompanyAddress(splitted[2]);
                                setSelectedcompanyPostalCode(splitted[3]);
                                setSelectedcompanyStatus(splitted[4]);
                                setSelectedcompanyCountry(splitted[5]);
                                setSelectedcompanyStreet(splitted[6]);
                                setSelectedcompanyHouseNumber(splitted[7]);
                                setselectedAddress(splitted[1]);
                            }}
                            className="w-full p-2 border border-gray-300 rounded-md bg-[#EAEAEA] text-[#707070] outline-none"
                        >
                            <option>Company Name</option>
                            {companydata.map((value, index) => (
                                <option
                                    value={`${value.title}__${value.company_number}__${value.address_snippet}__${value.address.postal_code}__${value.company_status}__${value.address.country}__${value.address.locality}__${value.address.premises}`}
                                    key={index}
                                >
                                    {value.title} - {value.company_number} - {value.company_status}
                                </option>
                            ))}
                        </select>
                    )}

                    {/* Company Activity */}
                    <input
                        type="text"
                        placeholder="Enter Your Company Activity"
                        className="w-full p-2 outline-none rounded-md bg-custom-gray-light placeholder:text-[#000000] placeholder:text-sm"
                        value={activity}
                        onChange={(e) => setActivity(e.target.value)}
                    />

                    {/* Turnover */}
                    <input
                        type="text"
                        placeholder="Enter Your Expected TurnOver Per Annum"
                        className="w-full p-2 outline-none rounded-md bg-custom-gray-light placeholder:text-[#000000] placeholder:text-sm"
                        value={turnover}
                        onChange={(e) => setTurnover(e.target.value)}
                    />

                    {/* Submit Button */}
                    <PrimaryButton onClick={submitData} label={"Continue"} loading={loading} />
                </div>
            </div>
        </div>
    );
}
